const MerchantProfile = () => <div>MerchantProfile</div>;

export default MerchantProfile;
